export const passwordCardDeleteModal = {
	complement: {
		multiple: "the selected password cards?",
		single: "the password card from {{cardName}}",
	},
	confirmButton: "Yes, I want to block the password card",
	text:
		"In case of loss of a password card, it is advisable to block it. Upon confirming the block, your history is recorded, but it is no longer valid. Therefore, you want to block ",
};
